import { FC, useState } from 'react';
import { BrgButton, ButtonVariant, Colors, FInter, FlexBox, useIsMobile } from '@brg/ui';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { LayoutConst, useModal } from 'core';
import { RectangularButtonFilled, RectangularButtonHollow } from 'shared/components/buttons';
import { DatePickerWrapper } from "../../components/tagAdminProjectsSearchBar/tagAdminProjectsSearchBar";
import CheckboxField from 'shared/pages/projectEdit/components/CheckboxField';
import { AppTester } from 'supporting';

/**
 * @param Модалка для несохраненных данных @Artem
 */

export const BackLink = styled(FInter.SectionTitleDiv)`
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.71;
  }
`;

const OuterWrapper = styled(FlexBox)`
  position: fixed;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background: rgba(21, 21, 20, 0.60);
  backdrop-filter: blur(10px);
  z-index: 9999999999;
`;

const Wrapper = styled(FlexBox)`
  background-color: ${({ theme }) => theme.ageModal.bg};
  display: flex;
  width: 564px;
  padding: 32px 40px 40px 40px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  border-radius: 8px;

  .react-date-picker__inputGroup__day[value=''] {
    width: 180px !important;
    @media(max-width: ${LayoutConst.screen.m}px) {
      position: relative;
      top: 0;
      left: 0;
      transform: translateY(0);
      font-size: 1rem;
      line-height: 150%;
    }
    @media(max-width: ${LayoutConst.screen.s}px) {
      font-size: 20px;
      line-height: 25px;
      left: -1px;
    }
  }

  .react-date-picker__inputGroup {
    input, span {
      color: ${({ theme }) => theme.ageModal.input.color} !important;
    }

    .react-date-picker__inputGroup__divider {
      ::before {
        color: ${({ theme }) => theme.ageModal.input.color};
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 20px;
    line-height: 25px;
  }

  @media (max-width: ${LayoutConst.screen.sm}px) {
    width: 100%;
    border-radius: 8px 8px 0 0 ;
    position: fixed;
    bottom: 0;
  }
`;

const Title = styled(FInter.SectionTitle)<{ isMobile: boolean }>`
  
  letter-spacing: -0.6px;
  margin-bottom: 8px;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px; /* 133.333% */

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 23px;
    font-style: normal;
    font-weight: 600;
    line-height: 29px; /* 126.087% */
    letter-spacing: -0.46px;
  }
  
  @media (max-width: ${LayoutConst.screen.s}px) {
   
  }

  color: ${({ theme }) => theme.not_saved_modal.title};
`

const Button = css`
  width: calc((100% - 16px) / 2);
  height: 46px !important;
  font-weight: bold;

  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 100%;
    margin: 0;
  }
`

const ButtonLeft = styled(BrgButton)<{ isMobile: boolean }>`
  
  min-width: inherit;

  @media (max-width: ${LayoutConst.screen.s}px) {
    min-width: 77px;
    //height: 26px;
    //line-height: 20px;
    //font-size: 13px;
  }

  ${Button};
`

const ButtonRight = styled(BrgButton)<{ isMobile: boolean }>`
  
  min-width: inherit;
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    min-width: 77px;
    //height: 26px;
    //line-height: 20px;
    //font-size: 13px;
  }
  
  ${Button};
`

const DateWrapper = styled(DatePickerWrapper)<{showPlaceholder?: boolean}>`
  width: 100% !important;
  max-width: initial;

  .react-date-picker {
    max-width: initial !important;
    width: 100% !important;
    .react-date-picker__wrapper{
      width: 100% !important;
      max-width: 100% !important;
    }
    .react-date-picker__inputGroup{
      width: 100% !important;
      max-width: 100% !important;
    }
    .react-date-picker__inputGroup__day {
      max-width: ${p => p.showPlaceholder? 124 : 25}px;
      &::placeholder {
        ${p => !p.showPlaceholder && 'color: transparent !important;'}
      }
    }
  }

`

const Description = styled(FInter.SectionTitle)<{ isMobile: boolean, align?: string }>`
  margin-bottom: 32px;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 129.412% */
  letter-spacing: -0.34px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 133.333% */
    letter-spacing: -0.3px;
    margin-bottom: 24px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 123.077% */
  }
  
  color: ${({ theme }) => theme.not_saved_modal.title};
  text-align: ${({ align }) => align || 'initial'};
`

export const SelectLabel = styled.label`
  margin: 0 15px 8px 0;

  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 129.412% */
  color: ${Colors.galBlack47};

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 133.333% */
    letter-spacing: -0.3px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 123.077% */
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    margin-left: 0;
  }
`;

const ButtonWrapper = styled(FlexBox)`
  flex-direction: row;
  gap: 16px;
  
  @media (max-width: ${LayoutConst.screen.sm}px) {
    flex-direction: column;
    gap: 8px;
  }
`

export const AgeRestrictionModal: FC<{ callback: (value: boolean) => void }> = ({ callback }) => {
  const { t } = useTranslation();
  const modal = useModal();
  const isMobile = useIsMobile();
  const [step, setStep] = useState(1);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const isGeograffee = AppTester.isGeograffee();
  const isContinuumSite = AppTester.isContinuumSite();

  return (
    <OuterWrapper>
      <Wrapper direction={'column'} width={'100%'} justify='flex-start' align='flex-start'>
        <FlexBox direction={'column'} directionMobile='column' width={'100%'} justify={'flex-start'}
                 justifyMobile='center'
                 align={'flex-start'} alignMobile={'flex-start'}>
          {step === 1 && (
            <>
              <Title isMobile={isMobile}>
                {t('age_restricted_modal.title')}
              </Title>
              <Description isMobile={isMobile}>
                {t('age_restricted_modal.description')}
              </Description>
              <CheckboxField
                onClick={(value: any) => setIsConfirmed(!isConfirmed)}
                checked={isConfirmed}
                label={t('age_restricted_modal.label')}
                dark={!isGeograffee}
                isCGrave={isContinuumSite}
              />
              <ButtonWrapper offsetTop={40} offsetTopMobile={32} width="100%">
                <ButtonLeft
                variant={ButtonVariant.Hollow}
                  isMobile={isMobile}
                  onClick={() => {
                    callback(false);
                    setTimeout(() => modal.hide(), 1500)
                  }}
                >
                  {t('age_restricted_modal.cancel')}
                </ButtonLeft>
                <ButtonRight
                variant={ButtonVariant.Filled}
                  isMobile={isMobile}
                  disabled={!isConfirmed}
                  onClick={() => {
                    modal.hide();
                    callback(true);
                  }}>
                  {t('age_restricted_modal.proceed')}
                </ButtonRight>
              </ButtonWrapper>
            </>
          )}
          {step === 2 && (
            <>
              <FlexBox align="center" direction="column" directionMobile='column'>
                <Title isMobile={isMobile}>
                  {t('age_restricted_modal.title2')}
                </Title>
                <Description isMobile={isMobile} align="center">
                  {t('age_restricted_modal.description')}
                </Description>
              </FlexBox>
              <ButtonWrapper justify="center" width="100%">
                <ButtonRight
                  variant={ButtonVariant.Filled}
                  isMobile={isMobile}
                  onClick={() => {
                    modal.hide();
                    callback(false)
                  }}>
                  {t('age_restricted_modal.back')}
                </ButtonRight>
              </ButtonWrapper>
            </>
          )}
        </FlexBox>
      </Wrapper>
    </OuterWrapper>
  )
};import { FC, useState } from 'react';
import { BrgButton, ButtonVariant, Colors, FInter, FlexBox, useIsMobile } from '@brg/ui';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { LayoutConst, useModal } from 'core';
import { RectangularButtonFilled, RectangularButtonHollow } from 'shared/components/buttons';
import { DatePickerWrapper } from "../../components/tagAdminProjectsSearchBar/tagAdminProjectsSearchBar";
import CheckboxField from 'shared/pages/projectEdit/components/CheckboxField';
import { AppTester } from 'supporting';

/**
 * @param Модалка для несохраненных данных @Artem
 */

export const BackLink = styled(FInter.SectionTitleDiv)`
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.71;
  }
`;

const OuterWrapper = styled(FlexBox)`
  position: fixed;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background: rgba(21, 21, 20, 0.60);
  backdrop-filter: blur(10px);
  z-index: 9999999999;
`;

const Wrapper = styled(FlexBox)`
  background-color: ${({ theme }) => theme.ageModal.bg};
  display: flex;
  width: 564px;
  padding: 32px 40px 40px 40px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  border-radius: 8px;

  .react-date-picker__inputGroup__day[value=''] {
    width: 180px !important;
    @media(max-width: ${LayoutConst.screen.m}px) {
      position: relative;
      top: 0;
      left: 0;
      transform: translateY(0);
      font-size: 1rem;
      line-height: 150%;
    }
    @media(max-width: ${LayoutConst.screen.s}px) {
      font-size: 20px;
      line-height: 25px;
      left: -1px;
    }
  }

  .react-date-picker__inputGroup {
    input, span {
      color: ${({ theme }) => theme.ageModal.input.color} !important;
    }

    .react-date-picker__inputGroup__divider {
      ::before {
        color: ${({ theme }) => theme.ageModal.input.color};
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 20px;
    line-height: 25px;
  }

  @media (max-width: ${LayoutConst.screen.sm}px) {
    width: 100%;
    border-radius: 8px 8px 0 0 ;
    position: fixed;
    bottom: 0;
  }
`;

const Title = styled(FInter.SectionTitle)<{ isMobile: boolean }>`
  
  letter-spacing: -0.6px;
  margin-bottom: 8px;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px; /* 133.333% */

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 23px;
    font-style: normal;
    font-weight: 600;
    line-height: 29px; /* 126.087% */
    letter-spacing: -0.46px;
  }
  
  @media (max-width: ${LayoutConst.screen.s}px) {
   
  }

  color: ${({ theme }) => theme.not_saved_modal.title};
`

const Button = css`
  width: calc((100% - 16px) / 2);
  height: 46px !important;
  font-weight: bold;

  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 100%;
    margin: 0;
  }
`

const ButtonLeft = styled(BrgButton)<{ isMobile: boolean }>`
  
  min-width: inherit;

  @media (max-width: ${LayoutConst.screen.s}px) {
    min-width: 77px;
    //height: 26px;
    //line-height: 20px;
    //font-size: 13px;
  }

  ${Button};
`

const ButtonRight = styled(BrgButton)<{ isMobile: boolean }>`
  
  min-width: inherit;
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    min-width: 77px;
    //height: 26px;
    //line-height: 20px;
    //font-size: 13px;
  }
  
  ${Button};
`

const DateWrapper = styled(DatePickerWrapper)<{showPlaceholder?: boolean}>`
  width: 100% !important;
  max-width: initial;

  .react-date-picker {
    max-width: initial !important;
    width: 100% !important;
    .react-date-picker__wrapper{
      width: 100% !important;
      max-width: 100% !important;
    }
    .react-date-picker__inputGroup{
      width: 100% !important;
      max-width: 100% !important;
    }
    .react-date-picker__inputGroup__day {
      max-width: ${p => p.showPlaceholder? 124 : 25}px;
      &::placeholder {
        ${p => !p.showPlaceholder && 'color: transparent !important;'}
      }
    }
  }

`

const Description = styled(FInter.SectionTitle)<{ isMobile: boolean, align?: string }>`
  margin-bottom: 32px;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 129.412% */
  letter-spacing: -0.34px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 133.333% */
    letter-spacing: -0.3px;
    margin-bottom: 24px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 123.077% */
  }
  
  color: ${({ theme }) => theme.not_saved_modal.title};
  text-align: ${({ align }) => align || 'initial'};
`

export const SelectLabel = styled.label`
  margin: 0 15px 8px 0;

  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 129.412% */
  color: ${Colors.galBlack47};

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 133.333% */
    letter-spacing: -0.3px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 123.077% */
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    margin-left: 0;
  }
`;

const ButtonWrapper = styled(FlexBox)`
  flex-direction: row;
  gap: 16px;
  
  @media (max-width: ${LayoutConst.screen.sm}px) {
    flex-direction: column;
    gap: 8px;
  }
`

export const AgeRestrictionModal: FC<{ callback: (value: boolean) => void }> = ({ callback }) => {
  const { t } = useTranslation();
  const modal = useModal();
  const isMobile = useIsMobile();
  const [step, setStep] = useState(1);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const isGeograffee = AppTester.isGeograffee();
  const isContinuumSite = AppTester.isContinuumSite();

  return (
    <OuterWrapper>
      <Wrapper direction={'column'} width={'100%'} justify='flex-start' align='flex-start'>
        <FlexBox direction={'column'} directionMobile='column' width={'100%'} justify={'flex-start'}
                 justifyMobile='center'
                 align={'flex-start'} alignMobile={'flex-start'}>
          {step === 1 && (
            <>
              <Title isMobile={isMobile}>
                {t('age_restricted_modal.title')}
              </Title>
              <Description isMobile={isMobile}>
                {t('age_restricted_modal.description')}
              </Description>
              <CheckboxField
                onClick={(value: any) => setIsConfirmed(!isConfirmed)}
                checked={isConfirmed}
                label={t('age_restricted_modal.label')}
                dark={!isGeograffee}
                isCGrave={isContinuumSite}
              />
              <ButtonWrapper offsetTop={40} offsetTopMobile={32} width="100%">
                <ButtonLeft
                variant={ButtonVariant.Hollow}
                  isMobile={isMobile}
                  onClick={() => {
                    callback(false);
                    setTimeout(() => modal.hide(), 1500)
                  }}
                >
                  {t('age_restricted_modal.cancel')}
                </ButtonLeft>
                <ButtonRight
                variant={ButtonVariant.Filled}
                  isMobile={isMobile}
                  disabled={!isConfirmed}
                  onClick={() => {
                    modal.hide();
                    callback(true);
                  }}>
                  {t('age_restricted_modal.proceed')}
                </ButtonRight>
              </ButtonWrapper>
            </>
          )}
          {step === 2 && (
            <>
              <FlexBox align="center" direction="column" directionMobile='column'>
                <Title isMobile={isMobile}>
                  {t('age_restricted_modal.title2')}
                </Title>
                <Description isMobile={isMobile} align="center">
                  {t('age_restricted_modal.description')}
                </Description>
              </FlexBox>
              <ButtonWrapper justify="center" width="100%">
                <ButtonRight
                  variant={ButtonVariant.Filled}
                  isMobile={isMobile}
                  onClick={() => {
                    modal.hide();
                    callback(false)
                  }}>
                  {t('age_restricted_modal.back')}
                </ButtonRight>
              </ButtonWrapper>
            </>
          )}
        </FlexBox>
      </Wrapper>
    </OuterWrapper>
  )
};